import React from 'react';
import '../forms.css';
import FormLabel from '../formLabel';

const Buttons = props => {
	const { label, help, error, warning, id, children, mandatory, ...rest } = props;

	return (
		<div
			data-testid={rest['data-testid']}
			key={id}
			id={id}
			className={`form-group ${error ? 'has-error' : warning ? 'has-warning' : ''}`}
		>
			<FormLabel {...props} />
			<div className="btn-row">{children} </div>
			{error && <span className="help-block">{typeof error === 'function' ? error() : error}</span>}
			{warning && <span className="help-block">{typeof warning === 'function' ? warning() : warning}</span>}
		</div>
	);
};

export default Buttons;
